import { MasterBannerContext } from '../../../../contexts/MasterBannerContext';
import React, { useContext, useRef } from "react";
import { SettingsBannerContext } from '../../../../contexts/SettingsBannerContext';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import './index.css';
import { TextToSpeech } from "../../../IA/textToSpeech";

export default function AudioComponent(props) {
  const { layerActive, setLayerActive, setReload } = useContext(SettingsBannerContext);
  const { master, setMaster } = useContext(MasterBannerContext);
  const refAudioAsset = useRef(null);
  const refBGIcon = useRef(null);
  const type = props.type;
  var masterAudio = null;
  switch (type) {
    case "IA":
        if (master.audioIA && master.audioIA.name) {
            masterAudio = JSON.parse(JSON.stringify(master.audioIA));
        }
        break;
    case "trilha":
        if (master.audio && master.audio.name) {
            masterAudio = JSON.parse(JSON.stringify(master.audio));
        }
        break;
  }

  async function addAudio(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (evt) {
      const b64 = evt.currentTarget.result;
      var masterCopy = JSON.parse(JSON.stringify(master));
      const filename = file.name;
      let ext = filename.split('.');
      ext = ext[ext.length - 1];
      const audio = {
        b64: b64,
        name: filename,
        ext: ext,
        bg: true,
        delay: 0,
        direction: 'right'
      };
      if (type === 'IA') masterCopy.audioIA = audio;
      if (type === 'trilha') masterCopy.audio = audio;
      refAudioAsset.current.value = "";
      setMaster(masterCopy);
      setLayerActive(layerActive)
      setReload(true);
    };
    reader.onerror = function (error) {
      return null;
    };
  }

  async function deleteAudio() {
    var masterCopy = JSON.parse(JSON.stringify(master));
    if (type === 'IA') masterCopy.audioIA = { name: '' };
    if (type === 'trilha') masterCopy.audio = { name: '' };

    setMaster(masterCopy);
    setLayerActive(layerActive)
    setReload(true);
  }

  async function changeDirection() {
    var masterCopy = JSON.parse(JSON.stringify(master));
    if (masterCopy.audioIA && masterCopy.audioIA.b64) {
        const direction = masterCopy.audioIA.direction === 'left' ? 'right' : 'left';
        masterCopy.audioIA.direction = direction;        
    }
    if (masterCopy.audio && masterCopy.audio.b64) {
        const direction = masterCopy.audio.direction === 'left' ? 'right' : 'left';
        masterCopy.audio.direction = direction;
    }
    
    setMaster(masterCopy);
    setLayerActive(layerActive)
    setReload(true);
  }
 
  async function ChangeBGIcon(evt) {
    const value = evt.target.checked;
    var masterCopy = JSON.parse(JSON.stringify(master));
    if (masterCopy.audioIA && masterCopy.audioIA.b64) masterCopy.audioIA.bg = value;
    if (masterCopy.audio && masterCopy.audio.b64) masterCopy.audio.bg = value;  
    setMaster(masterCopy);
    setLayerActive(layerActive)
    setReload(true);
  }
  
  async function ChangeDelay(evt) {
    const value = evt.target.value.replace(",", ".");
    var masterCopy = JSON.parse(JSON.stringify(master));
    if (type === 'IA') masterCopy.audioIA.delay = value;
    if (type === 'trilha') masterCopy.audio.delay = value;
    setMaster(masterCopy);
    setLayerActive(layerActive)
    setReload(true);
  }
    return (
        <div className="contentsAudio">
            <div
            style={{
              width: '200px',
              height: '35px',
              background: '#F7F7F7',
              position: 'relative',
              margin: '15px 4px 0px -7px',
              border: 'none',
              display: type === 'IA' && !masterAudio ? 'none' : 'flex',
            }}
            className={masterAudio ? "botao_layer botao_focus" : "botao_layer"}
            >
              <VolumeUpIcon style={{marginLeft: '15px'}} onClick={() => refAudioAsset.current.click()}/>
              <span onClick={() => refAudioAsset.current.click()} className="layer-span" style={{fontSize: '14px', fontWeight: 'normal', color: '#1B9ADA', margin: '0 10px 0 10px', overflow: 'hidden', textOverflow:'ellipsis', width: '100px', whiteSpace: 'nowrap'}}>
                {masterAudio ? masterAudio.name : "Adicionar áudio"}
              </span>
            
              <div style={{display: 'block',  position: 'absolute', right: '8px', top: '6px'}}></div>            
              {
                masterAudio ?
              <div style={{display: 'flex'}}>
                <DeleteForeverIcon onClick={() => deleteAudio()} style={{zIndex: 999}}/>
                <ArrowForwardIcon
                onClick={() => changeDirection()}
                style={{
                    color: '#1B9ADA',
                    Index: 999,
                    transform: masterAudio.direction === 'left' ? 'rotate(180deg)' : 'rotate(0deg)'
                    }}
                />
                <input onChange={(evt) => ChangeBGIcon(evt)} defaultChecked={masterAudio.bg} ref={refBGIcon} type="checkbox"/>
              </div>
              :
              <></>
            }
            <input
                onChange={(e) => addAudio(e.target.files[0])}
                ref={refAudioAsset}
                accept=".mp3, .wav|audio/*"
                type='file'
                style={{display: 'none'}}
            />
            </div>
            {
                type === 'IA' && !masterAudio ?
                <div className="tts-div">
                    <TextToSpeech/>
                </div> : <></>
            }
            <input disabled={!masterAudio}style={{opacity: masterAudio ? 1 : 0.3}} placeholder={masterAudio ? masterAudio.delay : 0} className="audio-delay" onBlur={(evt) => ChangeDelay(evt)}/>
        </div>
    )
}